import { Addon, EntityType } from "../../../api/grpc/subscription/subscription";

// Display order for subscription items, shared by Billing and the Product Store.
const ITEM_ORDER = [
  EntityType.ROOM,
  EntityType.USER,
  EntityType.DESK,
  EntityType.WAYFINDER,
];

const getItemRank = (item: Addon) => {
  const rank = ITEM_ORDER.indexOf(item.entityType);
  return rank === -1 ? ITEM_ORDER.length : rank;
};

/**
 * Countable subscription items (rooms, users, desks, wayfinders) in display
 * order. User and users-pack add-ons are merged into a single Users item.
 */
export const getSubscriptionItems = (addons: Addon[]): Addon[] => {
  const firstUserAddon = addons.find(
    (item) => item.entityType === EntityType.USER
  );
  const firstUsersPackAddon = addons.find(
    (item) => item.entityType === EntityType.USERS_PACK
  );
  const totalUsers = addons.reduce(
    (total, item) =>
      item.entityType === EntityType.USER ||
      item.entityType === EntityType.USERS_PACK
        ? total + item.quantity
        : total,
    0
  );

  const items = addons
    .filter(
      (item) =>
        item.entityType !== EntityType.CROSS_ORG_ROOM_CALENDARS &&
        item.entityType !== EntityType.TOTAL_CARE_SUPPORT &&
        item.entityType !== EntityType.USERS_PACK &&
        (item.entityType !== EntityType.USER || item === firstUserAddon)
    )
    .map((item) =>
      item.entityType === EntityType.USER
        ? { ...item, quantity: totalUsers }
        : item
    );

  if (!firstUserAddon && firstUsersPackAddon) {
    items.push({
      ...firstUsersPackAddon,
      name: "USER",
      entityType: EntityType.USER,
      quantity: totalUsers,
    });
  }

  return items.sort((a, b) => getItemRank(a) - getItemRank(b));
};

/** Subscription add-ons (currently Cross-Org Shared Room Calendars). */
export const getSubscriptionAddons = (addons: Addon[]): Addon[] =>
  addons.filter(
    (item) => item.entityType === EntityType.CROSS_ORG_ROOM_CALENDARS
  );
